export default __webpack_public_path__ + "static/media/ismaeel.c8731193.jpg";